<template>
    <component
        :is="componentName"
        v-bind="{
            page,
            scale,
            viewport,
            inScrollView,
            elementStyle,
            isScrolling,
            watermarkText
        }"
    >
        <template #default="{ loaded }">
            <!-- 骨架屏 -->
            <pdf-skeleton
                v-if="!loaded && inScrollView"
                :height="viewport.height"
            ></pdf-skeleton>
        </template>
    </component>
</template>
<script>
import PdfPageImage from './pdf-page-image.vue';
import PdfPageStream from './pdf-page-stream.vue';
import PdfSkeleton from './pdf-skeleton.vue';

export default {
    name: 'PdfPageRender',
    components: { PdfPageImage, PdfPageStream, PdfSkeleton },
    props: {
        scale: Number,
        page: Object,
        viewport: Object,
        isImage: Boolean,
        isScrolling: Boolean,
        inScrollView: Boolean,
        elementStyle: Object,
        watermarkText: String
    },
    data() {
        return {};
    },
    computed: {
        componentName() {
            return this.isImage ? 'PdfPageImage' : 'PdfPageStream';
        }
    }
};
</script>
